import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import Input from 'Components/Atoms/Input/Input';
import { useTranslation } from 'react-i18next';
import OutlineSearch from 'Components/Atoms/OutlineIcons/OutlineSearch';
import Spinner from 'Components/Atoms/Spinner';
import clsx from 'clsx';

export default function MultiselectFilter(props) {
    const { value, onChange, className, isBusy } = props;
    const { t } = useTranslation('common');

    return (
        <div className={cn('p-2 sticky top-0 bg-white z-10', className)}>
            <Input
                value={value}
                onChange={onChange}
                placeholder={t('filter-placeholder')}
                className={clsx('pl-8', isBusy && 'pr-8')}
                size="small"
                autoFocus
            />

            <OutlineSearch
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                size={18}
            />

            {isBusy && (
                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
                    <Spinner size={18} />
                </div>
            )}
        </div>
    );
}

MultiselectFilter.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    isBusy: PropTypes.bool,
};
